import React, {
   forwardRef,
   useCallback,
   useImperativeHandle,
   useState,
} from "react";
import ClaimProfilePopUp from "./ClaimProfilePopUp";
import { BenefitPopUpRef } from "./types";

export interface ClaimProfilePopUpWrapperProps {
   venueId: Guid;
   initialOpen: boolean;
}

const ClaimProfilePopUpWrapper = forwardRef<
   BenefitPopUpRef,
   ClaimProfilePopUpWrapperProps
>(({ venueId, initialOpen }, ref) => {
   const [isBenefitPopUpOpen, setIsBenefitPopUpOpen] = useState(initialOpen);

   const toggleBenefitPopUp = useCallback(() => {
      setIsBenefitPopUpOpen((s) => !s);
   }, []);

   useImperativeHandle(
      ref,
      () => ({
         toggle: toggleBenefitPopUp,
      }),
      [toggleBenefitPopUp]
   );

   return isBenefitPopUpOpen ? (
      <ClaimProfilePopUp toggle={toggleBenefitPopUp} venueId={venueId} />
   ) : null;
});

export default ClaimProfilePopUpWrapper;
